import { isChatSpace } from "@circle-react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types";
import { useNotificationBell } from "../../SpaceHeaderActions/NotificationBellDropdown/useNotificationBell";
import { ChatNotificationsSectionV3 } from "../ChatNotificationsSectionV3";
import { NotificationsSection } from "../NotificationsSection";

export interface NotificationsOptionsProps {
  space: Space;
}

export const NotificationsOptions = ({ space }: NotificationsOptionsProps) => {
  const {
    updateSpaceMemberNotificationPreferences,
    updateChatSpaceMemberNotificationPreferences,
    notificationState,
    shouldShowNotificationsSection,
  } = useNotificationBell({ space });

  if (!shouldShowNotificationsSection) {
    return null;
  }

  if (isChatSpace(space)) {
    return (
      <ChatNotificationsSectionV3
        updateSpaceMemberNotificationPreferences={
          updateChatSpaceMemberNotificationPreferences
        }
        notificationState={notificationState}
      />
    );
  }

  return (
    <NotificationsSection
      updateSpaceMemberNotificationPreferences={
        updateSpaceMemberNotificationPreferences
      }
      notificationState={notificationState ?? {}}
      space={space}
    />
  );
};
